module.exports = __webpack_public_path__ + "img/icon_circle_chevron.2fb76bc4.svg";